<script>
import {
    BFormGroup, BFormInput, BFormTextarea, BTab, BTabs,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { i18nApi } from '@core/api'

export default {
    components: {
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTab,
        BTabs,
        ValidationProvider,
    },
    props: {
        value: {
            type: Object,
            default() {
                return {}
            },
        },
        fields: {
            type: Array,
            default() {
                return []
            },
        },
        defaultValues: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            languages: [],
        }
    },
    watch: {
        value() {
            this.ensureTranslations()
        },
    },
    created() {
        i18nApi.getLanguages().then(r => {
            this.languages = r.data
            this.ensureTranslations()
        })
    },
    methods: {
        ensureTranslations() {
            this.languages.forEach(language => {
                if (!this.value[language.code]) {
                    this.$set(this.value, language.code, { ...this.defaultValues })
                }

                this.fields.forEach(field => {
                    if (typeof this.value[language.code][field.key] === 'undefined') {
                        this.$set(
                            this.value[language.code],
                            field.key,
                            Object.prototype.hasOwnProperty.call(this.defaultValues, field.key)
                                ? this.defaultValues[field.key]
                                : '',
                        )
                    }
                })
            })
        },
        rules(field, language) {
            if (field.requiredIn && field.requiredIn.includes(language.code)) {
                return 'required'
            }

            return ''
        },
        inputType(field) {
            return field.type || 'input'
        },
        emit() {
            this.$emit('input', this.value)
        },
    },
}
</script>

<template>
    <b-tabs v-if="languages.length">
        <b-tab
            v-for="language in languages"
            :key="language.code"
            :title="language.code.toUpperCase()"
        >
            <b-form-group
                v-for="field in fields"
                :key="field.key"
                :label="field.label"
                :label-for="field.key + language.code"
            >
                <validation-provider
                    #default="{ errors }"
                    :name="language.title + ' ' + field.label"
                    :rules="rules(field, language)"
                >
                    <b-form-textarea
                        v-if="inputType(field) === 'textarea'"
                        :id="field.key + language.code"
                        v-model="value[language.code][field.key]"
                        :state="errors.length > 0 ? false : null"
                        :rows="field.rows || 2"
                        :placeholder="field.placeholder"
                        @input="emit"
                    />
                    <b-form-input
                        v-else
                        :id="field.key + language.code"
                        v-model="value[language.code][field.key]"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="field.placeholder"
                        @input="emit"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
        </b-tab>
    </b-tabs>
</template>
